import React, { useEffect, useState } from 'react';
import './style.css';
import Box from '@mui/material/Box';
import http from '../../services/http-service'
import { Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {  DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
 
import { toast } from 'react-toastify';
import { confirm } from 'react-confirm-box';
import Moment from 'moment';


function SetPayAttributes(props) {
    console.log('databymukul', props);
    const [tableRow, setTableRow] = useState([])
    const [openSpinner, setOpenSpinner] = useState(false);
    const [tableData, setTableData] = useState([])

    useEffect(() => {
        getPayAttributesList()
        // eslint-disable-next-line
    }, [])

    const onTrigger = (event) => {
        let data = {
            'viewSetAttrComponents': false,
            'payFrequency': '',
            'payDetermination': '',
            'fromSetAttributes': true
        }
        props.handleChildPayAttriutesCallback(data);
        event.preventDefault();
    }

    // const handleSubmit = () => {
    //     console.log('table data....',tableData)
    // }

    const handleSpinnerClose = () => {
        setOpenSpinner(false);
    };
    const handleSpinnerToggle = () => {
        setOpenSpinner(!openSpinner);
    };

    const getPayAttributesList = () => {
        let params = {
            'employer_code': props.payAttributes.employerCode,
            'pay_frequency': props.payAttributes.payFrequency,
            'pay_determination': props.payAttributes.payDetermination
        }

        handleSpinnerToggle()
        http('employer/employer_set_pay_attribues_view/', 'GET', '', params)
            .then(res => res.data)
            .then(res => {
                if (res.status) {

                    res.data.frequency_data.forEach(element => {
                        element['editable'] = false
                    })
                    setTableData(res.data.frequency_data)

                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId1"
                      })
                }
                handleSpinnerClose()
            },
                err => {
                    handleSpinnerClose()
                    console.log('err....', err)
                });
    }

    const handleSubmit = (event) => {
        let postData = {
            'employer_code': props.payAttributes.employerCode,
            'pay_frequency': props.payAttributes.payFrequency,
            'pay_determination': props.payAttributes.payDetermination,
            "data": tableData
        }
        handleSpinnerToggle()
        http('employer/employer_set_pay_attribues_view/', 'PUT', postData)
            .then(res => res.data)
            .then(res => {
                if (res.status) {
                    toast.success(res.message,{
                        toastId: "toastId2"
                      })
                    onTrigger(event)
                }
                else {
                    toast.error(res.message,{
                        toastId: "toastId3"
                      })
                }
                handleSpinnerClose()
            },
                err => {
                    handleSpinnerClose()
                    console.log('err....', err)
                });
    }

    const confirmSetPayAttributes = async (event) => {
        const message = 'Are you sure, you want to perform this action. Your previous settings will be removed?';
        const options = {
            title: "Confirm",
            labels: {
                confirmable: "Confirm",
                cancellable: "Cancel"
            },
            closeOnOverlayClick: false
        }
        const result = await confirm(message, options);
        if (result) {
            handleSubmit(event)
        }
        console.log("You click No!");
    };

    return (
        <div className=''>
            <Box sx={{ boxShadow: 3 }} className='padding3'>
                <Typography variant="h2" component="h2" className='settingTabHeading'>
                    Set Pay Attributes
                    <CloseIcon className='closeIcon' onClick={onTrigger} />
                </Typography>
                <Typography variant="h6" component="h6" className='settingverifyTxt'>
                    <span className='textBold'>Please enter the appropriate values associated with your <span className='greenText'>{props.payAttributes.payFrequency === 'bi_monthly' ? 'bi-monthly' : props.payAttributes.payFrequency}</span> pay candence; all fields mandatory except 'period'</span>
                </Typography>
                <Typography variant="h6" mt={3} component="h6" className='settingverifyTxt'>
                    <span className='textBold'>Check Month</span> : Month in which the paycheck is produced.
                </Typography>
                <Typography variant="h6" mt={1} component="h6" className='settingverifyTxt'>
                    <span className='textBold'>Period</span> : The payroll period number.
                </Typography>
                <Typography variant="h6" mt={1} component="h6" className='settingverifyTxt'>
                    <span className='textBold'>Period Start Date</span> : First day included in the pay period.
                </Typography>
                <Typography variant="h6" mt={1} component="h6" className='settingverifyTxt'>
                    <span className='textBold'>Period End Date</span> : Last day included in the pay period.
                </Typography>
                <Typography variant="h6" mt={1} component="h6" className='settingverifyTxt'>
                    <span className='textBold'>HR Cutoff Date</span> : Deadline date. Date by which personal deduction file impacting the pay period must be available to HR;
                    deduction file must be accessible by 5PM. HR will review and process all deduction files impacting the pay period received by this
                    date. Note: Incomplete, missing, or incorrect information may delay the processing of the deduction file.
                </Typography>
                <Typography variant="h6" mt={1} component="h6" className='settingverifyTxt'>
                    <span className='textBold'>Pay Check Date</span> : The date the employee is paid for the pay period in the form of a paycheck.
                </Typography>
                <div className='enrollTabDiv'>
                    <div className='customTable setTable'>
                        <table>
                            <thead>
                                <tr>
                                    <th>Check Month</th>
                                    <th>Period</th>
                                    <th>Period Start Date</th>
                                    <th>Period End Date</th>
                                    <th>HR Cutoff Date</th>
                                    <th>Pay Check Date</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    tableData.map((cell, index) => (
                                        <tr>
                                            <td> {cell.check_month} </td>
                                            <td>
                                                <TextField inputProps={{ type: 'number' }} disabled={!cell.editable} InputLabelProps={{ shrink: true }} fullWidth name='period' id="period" value={cell.period} onChange={(e) => {
                                                    tableData[index].period = e.target.value
                                                    setTableRow(tableData.map((obj, i) => i === index ? tableData[index] : obj))
                                                }} />
                                            </td>
                                            <td>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker disabled={!cell.editable} inputProps={{ type: "text", readOnly: true }} name='pay_begin_date' id="pay_begin_date" inputFormat="yyyy-MM-dd" value={Moment( cell.pay_begin_date)._d}
                                                        onChange={(date) => {
                                                            tableData[index].pay_begin_date = Moment(date).format('YYYY-MM-DD')
                                                            if ((cell.hr_cutof_date < cell.pay_begin_date) || (cell.hr_cutof_date > cell.pay_end_date)) {
                                                                tableData[index].hr_cutof_date = null
                                                            }
                                                            setTableRow(tableData.map((obj, i) => i === index ? tableData[index] : obj))
                                                        }}
                                                        renderInput={(params) => <TextField fullWidth InputLabelProps={{ shrink: true }} value={cell.pay_begin_date} name='pay_begin_date' id="pay_begin_date" inputProps={{ type: "text" }} {...params} />}
                                                    />
                                                </LocalizationProvider>
                                            </td>
                                            <td>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker disabled={!cell.editable} inputProps={{ type: "text", readOnly: true }} name='pay_end_date' id="pay_end_date" inputFormat="yyyy-MM-dd" value={Moment( cell.pay_end_date)._d}
                                                        onChange={(date) => {
                                                            
                                                            tableData[index].pay_end_date = Moment(date).format('YYYY-MM-DD')
                                                            if ((cell.hr_cutof_date < cell.pay_begin_date) || (cell.hr_cutof_date > cell.pay_end_date)) {
                                                                tableData[index].hr_cutof_date = null
                                                            }
                                                            setTableRow(tableData.map((obj, i) => i === index ? tableData[index] : obj))
                                                        }}
                                                        renderInput={(params) => <TextField fullWidth InputLabelProps={{ shrink: true }} value={cell.pay_end_date} name='pay_end_date' id="pay_end_date" inputProps={{ type: "text" }} {...params} />}
                                                    />
                                                </LocalizationProvider>
                                            </td>
                                            <td>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker sx={{border: '1px solid #d7d7d7 !important', color: '#d7d7d7'}} disabled={!cell.editable} inputProps={{ type: "text", readOnly: true }} name='hr_cutof_date' id="hr_cutof_date" inputFormat="yyyy-MM-dd" value={Moment( cell.hr_cutof_date)._d}
                                                        onChange={(date) => {
                                                            tableData[index].hr_cutof_date = Moment(date).format('YYYY-MM-DD')
                                                            setTableRow(tableData.map((obj, i) => i === index ? tableData[index] : obj))
                                                        }}
                                                        renderInput={(params) => <TextField fullWidth readOnly InputLabelProps={{ shrink: true }} value={cell.hr_cutof_date} name='hr_cutof_date' id="hr_cutof_date" inputProps={{ type: "text" }} {...params} />}
                                                    />
                                                </LocalizationProvider>
                                            </td>

                                            <td>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <DatePicker disabled={!cell.editable} inputProps={{ type: "text", readOnly: true }} name='check_date' id="check_date" inputFormat="yyyy-MM-dd" value={Moment( cell.check_date)._d}
                                                        onChange={(date) => {
                                                            tableData[index].check_date = Moment(date).format('YYYY-MM-DD')
                                                            setTableRow(tableData.map((obj, i) => i === index ? tableData[index] : obj))
                                                        }}
                                                        renderInput={(params) => <TextField fullWidth readOnly InputLabelProps={{ shrink: true }} value={cell.check_date} name='check_date' id="check_date" inputProps={{ type: "text" }} {...params} />}
                                                    />
                                                </LocalizationProvider>
                                            </td>
                                            <td> <button className='submitBtn' onClick={() => {
                                                tableData[index].editable = !tableData[index].editable
                                                setTableRow(tableData.map((obj, i) => i === index ? tableData[index] : obj))
                                            }}>Edit</button> </td>
                                        </tr>
                                    ))
                                }

                            </tbody>
                        </table>
                    </div>
                    <Box style={{ textAlign: 'right' }}>
                        <button className='btnSave bgRed' style={{ marginRight: '10px' }} onClick={onTrigger}>Cancel</button>
                        <button className='btnSave' onClick={confirmSetPayAttributes}>Save</button>
                    </Box>
                </div>
            </Box>
        </div>
    );
}

export default SetPayAttributes;